<template lang="html">
  <div class="col-sm-9 row">
    <div class="col-sm-4 paddingRight">
      <select id="inputState" class="form-control" v-model="p">
        <option selected value="">省</option>
        <option v-for="item in provences" :value="item">{{item}}</option>
      </select>
    </div>
    <div class="col-sm-4 paddingRight">
      <select id="inputState" class="form-control" v-model="c" :disabled="!p">
        <option selected value="">市</option>
        <option v-for="item in cities" :value="item">{{item}}</option>
      </select>
    </div>
    <div class="col-sm-4 paddingRight">
      <select id="inputState" class="form-control" v-model="a" >
        <option selected value="">区</option>
        <option v-for="item in areas" :value="item" @click="">{{item}}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      provences:[],
      cities:[],
      areas:[],
      p:'山东',
      c:'青岛',
      a:'市南区'
    }
  },
  methods:{
  },
  mounted(){
    this.provences = Object.keys(cities)
    this.p = '山东'
    this.c = '青岛'
    this.a = '市南区'
    this.cities = Object.keys(cities[this.p])
    this.areas = cities[this.p][this.c]
    let address = `${this.p}省${this.c}市${this.a}`
    this.$emit('getAddress',address)
  },
  watch:{
    p(val){
      if(val){
        this.cities = Object.keys(cities[val])
        this.c=""
        this.a=""
      }
    },
    c(val){
      if(val){
        this.areas = cities[this.p][val]
        this.a=""
      }
    },
    a(val){
      if(val){
        let address = ""
        if(this.p!=this.c){
          address = `${this.p}省${this.c}市${this.a}`
        }else{
          address = `${this.c}市${this.a}`
        }
        this.$emit('getAddress',address)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.paddingRight{padding-right: 0;}
select{font-size: 13px!important;padding-left: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/map.vue